import { useRef, useCallback, useState, useEffect } from 'react';

/**
 * Hook to lock mobile screen wake (keep screen on)
 * particularly useful for drivers/transporters using tracking
 */
export const useWakeLock = () => {
    const wakeLock = useRef<any>(null);
    const [isLocked, setIsLocked] = useState(false);

    const requestWakeLock = useCallback(async () => {
        if ('wakeLock' in navigator) {
            try {
                wakeLock.current = await (navigator as any).wakeLock.request('screen');

                wakeLock.current.addEventListener('release', () => {
                    console.log('💡 Wake Lock released');
                    setIsLocked(false);
                });

                console.log('💡 Wake Lock active');
                setIsLocked(true);
            } catch (err: any) {
                console.error(`❌ Wake Lock error: ${err.name}, ${err.message}`);
            }
        } else {
            console.warn('⚠️ Wake Lock API not supported');
        }
    }, []);

    const releaseWakeLock = useCallback(async () => {
        if (wakeLock.current) {
            try {
                await wakeLock.current.release();
                wakeLock.current = null;
            } catch (err: any) {
                console.error('❌ Error releasing Wake Lock:', err);
            }
        }
    }, []);

    // Re-request lock when page becomes visible again
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible' && !wakeLock.current) {
                requestWakeLock();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [requestWakeLock]);

    return { isLocked, requestWakeLock, releaseWakeLock };
};
